var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{class:(_vm.eventTypeClasses + " " + _vm.iconSizeClass + " mr-1")}),_c('span',{staticClass:"d-none d-lg-inline-flex"},[_vm._v(_vm._s(_vm.eventTypeLabel))])])}
var staticRenderFns = []

export { render, staticRenderFns }